import Events from '_utils/events';
import { cloneDeep } from '_utils';
import { _LOAD_MODEL_, MODEL } from '../components/PuzzleModel';

export default {
  computed: {
    storePuzzle() {
      return this.$store.state.puzzle.puzzle;
    },
    puzzle() {
      if (this.storePuzzle) return this.storePuzzle;
      return cloneDeep(MODEL);
    },
  },
  watch: {
    storePuzzle: {
      immediate: true,
      handler(puzzle) {
        if (puzzle) {
          Events.$emit(_LOAD_MODEL_, puzzle);
        }
      },
    },
  },
};
